













































































































































































































































































































































































































import { DetalhesDoPagamento, ItemDaVendaComReferencias, Venda, VendaComReferencias } from '@/models'
import { TipoDeProcesso } from '@/models/anexo/AnexoDosProcessos'
import { formatarMoeda } from '@/shareds/formatadores'
import { imprimirRomaneio, gerarComprovanteDeDemonstracao80mm } from '@/shareds/pedidos/impressao-de-romaneio'
import { contarItensDaVenda, obterTrocoDaVenda, obterValorAPagar, obterTotalDaVenda, obterTotalPagoDaVenda,
	imprimirConfissaoDeDivida, imprimirCarneDeCrediario, imprimirCarneDeCrediarioEConfissao } from '@/shareds/venda-shareds'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import { EditarUmaVendaUseCase, FindClienteUseCase, FindLojaUseCase, FindVendaUseCase, PluginMensageriaAlmodeUseCase, ValePresenteUseCase } from '@/usecases'
import { Vue, Component } from 'vue-property-decorator'
import CampoDeTelefone from '../ui/CampoDeTelefone.vue'
import { obrigatorio } from '@/shareds/regras-de-form'
import { imprimirQrCodesDosValesPresentes } from '@/shareds/venda-shareds'
import { VendaVitrineVirtualModule } from '@/store/vuex/produto/VendaVitrineVirtualStore'
import { imprimirCupomSemValorFiscal } from '@/shareds/pedidos/impressao-cupom-sem-valor-fiscal'
import { Inject } from 'inversify-props'
import type{ PagamentoServiceAdapter } from '@/usecases'


@Component({
	components:{
		CampoDeTelefone,
	}})
export default class DialogoDeImpressaoDeRomaneio extends Vue {
	
	vendaLocal = JSON.parse(localStorage.getItem('ULTIMA_VENDA') || 'null');
	syncMostra = false
	itensDaVenda: ItemDaVendaComReferencias[] = []
	vendaComReferencias: VendaComReferencias | null = null
	vendas: Venda | null = null
	statusPluginZeveo = false
	mostraDialogoTelefone = false
	novoTelefone = ''
	obrigatorio = obrigatorio
	enviandoValePresente = false
	processandoImpressao = false
	possuiValePresente = false
	possuiTelefoneDoCliente = false
	vendaVitrineStorage  = JSON.parse(localStorage.getItem('VENDA_VITRINE_VIRTUAL_STORAGE') || 'null');
	statusPluginAlmode = false

	findVendaUseCase = new FindVendaUseCase()
	findLojaUseCase = new FindLojaUseCase()
	vendaUseCase = new EditarUmaVendaUseCase()
	findClienteUseCase = new FindClienteUseCase()
	valePresenteUseCase = new ValePresenteUseCase()
	pluginMensageriaAlmodeUseCase = new PluginMensageriaAlmodeUseCase()

	formatarMoeda = formatarMoeda
	contarItensDaVenda = contarItensDaVenda

	@Inject('PagamentoServiceAdapter')
	private pagamentoService!: PagamentoServiceAdapter

	get restante() {
		return obterValorAPagar(this.vendaLocal)
	}

	get troco() {
		return obterTrocoDaVenda(this.vendaLocal)
	}

	get totalDaVenda() {
		return obterTotalDaVenda(this.vendaLocal)
	}

	get totalPago() {
		return obterTotalPagoDaVenda(this.vendaLocal)
	}

	get turnoDeVenda() {
		return VendaModule.turnoDeVenda
	}

	async novaVenda() {
		if (this.turnoDeVenda) {
			try{
				this.syncMostra = false
				localStorage.setItem('TELA_DE_IMPRESSAO_DE_ROMANEIO', JSON.stringify(false));
				localStorage.setItem('VENDA_CONFERIDA_POR_RFID', JSON.stringify(false))
				VendaVitrineVirtualModule.resetar()
			} catch(e) {
				AlertModule.setError(e)
			}
		}
	}

	created(){
		this.syncMostra = JSON.parse(localStorage.getItem('TELA_DE_IMPRESSAO_DE_ROMANEIO') || 'false');
		if(localStorage.getItem('TURNO_DE_VENDA_STORAGE') === null){
			localStorage.setItem('TELA_DE_IMPRESSAO_DE_ROMANEIO', JSON.stringify(false));
		}
		this.verificarPluginConfigurado()
	}

	async mostrar(possuiValePresente: boolean, possuiTelefoneDoCliente: boolean) {
		this.vendaLocal = JSON.parse(localStorage.getItem('ULTIMA_VENDA') || 'null');

		if (!this.vendaLocal) {
			localStorage.setItem('TELA_DE_IMPRESSAO_DE_ROMANEIO', JSON.stringify(false));
			this.syncMostra = false
			return
		}

		this.syncMostra = true
		localStorage.setItem('TELA_DE_IMPRESSAO_DE_ROMANEIO', JSON.stringify(true));
		this.possuiValePresente = possuiValePresente
		this.possuiTelefoneDoCliente = possuiTelefoneDoCliente
		this.vendaVitrineStorage = JSON.parse(localStorage.getItem('VENDA_VITRINE_VIRTUAL_STORAGE') || 'null');
	}

	async imprimirPdfA4Romaneio() {
		if (!this.vendaLocal) return

		this.vendaComReferencias = await this.findVendaUseCase.getVendaComReferencias(this.vendaLocal.id)
		const usuarioId = UserLoginStore.usuario?.id
		const qrData = `${this.extractDomain(window.location.href)}/anexo/${this.$route.fullPath.replace("/", "") as TipoDeProcesso}/${this.vendaLocal.id}/${usuarioId}`
		const produtosComReferencia = this.vendaComReferencias?.itens
		try {
			const vendaImpressao = await this.findVendaUseCase.get(this.vendaLocal.id)
			await imprimirRomaneio(vendaImpressao, qrData, produtosComReferencia)
		} catch (error) {
			AlertModule.setError(error)
		}
	}

	async gerarComprovanteDeDemonstracao80mm() {
		if (!this.vendaLocal) return
		this.vendaComReferencias = await this.findVendaUseCase.getVendaComReferencias(this.vendaLocal.id)
		const usuarioId = UserLoginStore.usuario?.id
		const qrData = `${this.extractDomain(window.location.href)}/anexo/${this.$route.fullPath.replace("/", "") as TipoDeProcesso}/${this.vendaLocal.id}/${usuarioId}`
		const produtosComReferencia = this.vendaComReferencias?.itens
		try {
			const vendaImpressao = await this.findVendaUseCase.get(this.vendaLocal.id)
			await gerarComprovanteDeDemonstracao80mm(qrData, produtosComReferencia, vendaImpressao)
		} catch (error) {
			AlertModule.setError(error)
		}
	}

	checkCrediario() {
		return this.vendaLocal.pagamentos.some(pagamento =>
			pagamento.tipoDePagamento.formaDePagamento === 'Crediário' || pagamento.tipoDePagamento.formaDePagamento === 'Boleto')
	}

	async imprimirConfissaoDeDivida(){
		try {
			await imprimirConfissaoDeDivida(this.vendaLocal.id)
		} catch (error: any) {
			AlertModule.setError(error)
		}	
	}

	async imprimirCarneDeCrediario(){
		try {
			await imprimirCarneDeCrediario(this.vendaLocal.id)
		} catch (error: any) {
			AlertModule.setError(error)
		}	
	}

	extractDomain(url) {
		let domain = url.replace(/^https?:\/\//, '')
		domain = domain.split('/')[0]
		domain = domain.split(':')[0]

		return domain;
	}

	async enviarNotaPorWhatsApp(){
		if (!this.vendaLocal.id) return
		try{
			const cliente = await this.findClienteUseCase.findClienteByCpfOuCnpj(this.vendaLocal.cpfDoCliente)
			if(cliente.telefones.length === 0){
				this.mostraDialogoTelefone = true
			}
			else {
				let enviarMensagem
				if (this.statusPluginAlmode){
					enviarMensagem = await this.pluginMensageriaAlmodeUseCase.enviaComprovanteDaVendaViaMensageriaAlmode(this.vendaLocal.id)
				} else {
					enviarMensagem = await this.vendaUseCase.disparoDeMensagemVenda(this.vendaLocal.id)
				}
				this.$emit('confirmado', enviarMensagem)
				AlertModule.setSuccess('Mensagem enviada com sucesso.')
			}
		} catch(error: any){
			AlertModule.setError(error)
		}
		finally{
			this.novoTelefone = ''
		}
	}

	async pluginMensagemConfiguradoZeveo(){
		const lojaId = this.vendaLocal.pontoDeVenda.loja.id
		const possuiConfiguracao = await this.findLojaUseCase.possuiPluginDeMensageriaConfigurado(lojaId, false)
		return possuiConfiguracao
	}

	async verificarPluginConfigurado() {
		this.statusPluginZeveo = await this.pluginMensagemConfiguradoZeveo()
		this.statusPluginAlmode = await this.pluginAlmodeMensageriaInternoConfigurado()
	}

	async salvarTelefone() {
		const telefoneRegex = /^\(\d{2}\) \d{4,5}-\d{4}$/;
		if (!this.novoTelefone || !telefoneRegex.test(this.novoTelefone.trim())) {
			AlertModule.setError('Informe um número de telefone válido no formato (XX) XXXXX-XXXX.');
			return;
		}
		const telefoneFormatado = String(this.novoTelefone).trim();

		try {
			let enviarMensagem
			if (this.statusPluginAlmode) {
				enviarMensagem = await this.pluginMensageriaAlmodeUseCase.enviaComprovanteDaVendaViaMensageriaAlmode(this.vendaLocal.id, telefoneFormatado)
			} else {
				enviarMensagem = await this.vendaUseCase.disparoDeMensagemVenda(this.vendaLocal.id, telefoneFormatado)
			}
			this.$emit('confirmado', enviarMensagem);
			AlertModule.setSuccess('Mensagem enviada com sucesso.');
        
			this.mostraDialogoTelefone = false;
		} catch (error: any) {
			AlertModule.setError('Erro ao enviar a mensagem.');
		} finally {
			this.novoTelefone = ''; 
		}
	}

	async enviarValePresentePorWhatsApp(){
		if (!this.vendaLocal.id) return
		try{
			this.enviandoValePresente = true
			let enviarMensagem
			if (this.statusPluginAlmode) {
				enviarMensagem = await this.pluginMensageriaAlmodeUseCase.enviaValePresenteViaMensageriaAlmode(this.vendaLocal.id)
			} else {
				enviarMensagem = await this.valePresenteUseCase.enviarValePresentePorWhatsapp(this.vendaLocal.id)
			}
			this.$emit('confirmado', enviarMensagem)
			AlertModule.setSuccess('Mensagem enviada com sucesso.')
			
		} catch(error: any){
			AlertModule.setError(error)
		}
		finally{
			this.enviandoValePresente = false
		}
	}

	async imprimirQrCodesDosValesPresentes(){
		this.processandoImpressao = true
		try {
			await imprimirQrCodesDosValesPresentes(this.vendaLocal.id)
		} catch (error: any) {
			AlertModule.setError(error)
			this.processandoImpressao = false
		} finally {
			this.processandoImpressao = false
		}	
	}

	isAgruparConfissaoEDivida(){
		return this.vendaLocal &&
			this.vendaLocal.pontoDeVenda &&
			this.vendaLocal.pontoDeVenda.loja &&
			this.vendaLocal.pontoDeVenda.loja.configuracaoDaLoja &&
			this.vendaLocal.pontoDeVenda.loja.configuracaoDaLoja.unificarCarneEhConfissaoDeDivida
	}

	async imprimirCarneDeCrediarioEConfissao(){
		this.processandoImpressao = true
		try {
			await imprimirCarneDeCrediarioEConfissao(this.vendaLocal.id)
		} catch (error: any) {
			AlertModule.setError(error)
			this.processandoImpressao = false
		} finally {
			this.processandoImpressao = false
		}	
	}

	get vendaVitrineLocal(): Venda | null {
		return this.vendaVitrineStorage?.venda || null
	}

	get restanteVendaDaVitrine() {
		if (!this.vendaVitrineLocal) return 0
		return obterValorAPagar(this.vendaVitrineLocal)
	}

	get trocoVendaDaVitrine() {
		if (!this.vendaVitrineLocal) return 0
		return obterTrocoDaVenda(this.vendaVitrineLocal)
	}

	get totalPagoDaVendaDaVitrine() {
		if (!this.vendaVitrineLocal) return 0
		return obterTotalPagoDaVenda(this.vendaVitrineLocal)
	}

	get totalDaVendaDaVitrine() {
		if (!this.vendaVitrineLocal) return 0
		return obterTotalDaVenda(this.vendaVitrineLocal)
	}

	async imprimirComprovanteDeVendaVitrine(){
		if (!this.vendaVitrineLocal) return
		
		try {
			this.processandoImpressao = true
			const vendaComItens = await this.findVendaUseCase.get(this.vendaVitrineLocal.id)

			const pagamentos = vendaComItens.pagamentos.filter(pagamento => pagamento.detalhesDoPagamentoId !== null)

			const detalhesDosPagamentos: DetalhesDoPagamento[] = []

			pagamentos.forEach(async (pagamento) => {
				if (pagamento.detalhesDoPagamentoId) {
					const detalhesDoPagamento = await this.pagamentoService.buscarDetalhesDoPagamento(pagamento.detalhesDoPagamentoId)
					detalhesDosPagamentos.push(detalhesDoPagamento)
				}
			})

			await imprimirCupomSemValorFiscal(vendaComItens, detalhesDosPagamentos)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.processandoImpressao = false
		}
	}
   
	async pluginAlmodeMensageriaInternoConfigurado(){
		const lojaId = this.vendaLocal.pontoDeVenda.loja.id
		const possuiConfiguracao = await this.findLojaUseCase.possuiPluginDeMensageriaConfigurado(lojaId, true)
		return possuiConfiguracao
	}
}
